import { render, staticRenderFns } from "./CodeEditor.vue?vue&type=template&id=2ccf14a6&scoped=true&"
import script from "./CodeEditor.vue?vue&type=script&lang=js&"
export * from "./CodeEditor.vue?vue&type=script&lang=js&"
import style0 from "./CodeEditor.vue?vue&type=style&index=0&id=2ccf14a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccf14a6",
  null
  
)

export default component.exports